import { useState, useEffect } from "react";
import { Accessibility, X } from "lucide-react";

import { useI18n } from "@/i18n/I18nContext";

// One-time, non-blocking hint shown on first app open (login page):
// accessibility settings are already available before login. It does not
// interrupt the login flow (no modal), is keyboard operable (real dismiss
// button) and announced to screen readers via role="status" + aria-live.
const SEEN_KEY = "visibilis_a11y_hint_seen";

export function LoginA11yHint() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(SEEN_KEY)) {
        setShow(true);
        localStorage.setItem(SEEN_KEY, "1"); // show only once, ever
      }
    } catch (_) {
      /* ignore */
    }
  }, []);

  if (!show) return null;

  return (
    <div className="mb-[17px]">
      <div
        role="status"
        aria-live="polite"
        data-testid="login-a11y-hint"
        className="flex items-start gap-2.5 rounded-[12px] bg-v3-lilac px-4 py-3 text-[14px] text-v3-ink"
      >
        <Accessibility className="mt-0.5 h-4 w-4 shrink-0 text-v3-magenta" aria-hidden="true" />
        <p className="flex-1 leading-snug">{t("member.login.a11y_hint")}</p>
        <button
          type="button"
          onClick={() => setShow(false)}
          data-testid="login-a11y-hint-dismiss"
          aria-label={t("common.close")}
          className="shrink-0 rounded-md p-0.5 text-v3-muted transition-colors hover:text-v3-ink"
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
